import styled from '@emotion/styled';
import Button, { buttonClasses } from '@mui/material/Button';

import { PaletteColor } from '../../styling/AppStyles';

/**
 * A MUI <Button> with custom styles
 */
const ExinMuiButton = styled(Button)`
  background-color: ${PaletteColor.bright};
  border: 1px solid ${PaletteColor.bright};
  border-width: 2px;
  border-radius: 50px;
  font-size: 1rem;
  line-height: 1.5rem;
  padding: 0.75rem 1.8rem;
  text-transform: none;
  &.${buttonClasses.text} {
    color: ${PaletteColor.white};
  }
  &:hover {
    background-color: ${PaletteColor.bright};
    border-color: ${PaletteColor.bright};
    color: ${PaletteColor.white};
  }
  &.${buttonClasses.disabled} {
    color: ${PaletteColor.brightDisabled};
    background-color: ${PaletteColor.white};
    border-color: ${PaletteColor.brightDisabled};
  }
`;

export default ExinMuiButton;
